import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {JourneyWDto} from '@cohort/wallet-schemas/campaign';
import {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

type JourneyStepsProgressionProps = {
  steps: JourneyWDto['steps'];
};

const JourneyStepsProgression: React.FC<JourneyStepsProgressionProps> = ({steps}) => {
  const {t} = useTranslation('components', {keyPrefix: 'space.journeyStepsProgression'});
  const {hasDarkBg, accentColor} = useThemeContext();

  if (steps.length === 0) {
    return <Fragment />;
  }
  const completedSteps = steps.filter(step => step.isCompleted).length;

  return (
    <div className="flex items-center gap-2">
      <ul
        className={classNames(
          'grid h-[12px] flex-grow list-none grid-flow-col gap-0.5 overflow-hidden rounded-xl',
          hasDarkBg ? 'bg-white/8' : 'bg-black/4'
        )}
      >
        {steps.map((step, idx) => (
          <li
            key={step.id}
            className={classNames('h-full', hasDarkBg ? 'bg-white/8' : 'bg-black/4')}
            style={{backgroundColor: idx < completedSteps ? accentColor : undefined}}
          ></li>
        ))}
      </ul>
      <span className="text-xs font-medium">
        {completedSteps}/{steps.length} {t('doneLabel', {count: completedSteps})}
      </span>
    </div>
  );
};

export default JourneyStepsProgression;
